import ApiClient from '../shared/ApiCliente';

export type TeseTemaDto = {
  id?: string;
  nome: string;
  termosBusca: string[];
  posX: number;
  posY: number;
  sentimento?: string | null;
  contexto?: string | null;
  gl?: string | null;
  hl?: string | null;
  ceid?: string | null;
};

export type GoogleNewsPaisDto = {
  country: string;
  countryEn: string;
  gl: string;
  hl: string;
  ceid: string;
  param_news_location?: string;
};

export type TeseSummaryDto = {
  id: string;
  nome: string;
  tickerEmpresa: string;
  totalTemas: number;
};

export type TeseDetailDto = {
  id: string;
  nome: string;
  tickerEmpresa: string;
  temas: TeseTemaDto[];
};

export type SaveTeseRequestDto = {
  /** Quando definido, atualiza a tese existente em vez de criar outra. */
  id?: string;
  nomeTese: string;
  tickerEmpresa: string;
  temas: TeseTemaDto[];
};

export type BillingUsageDto = {
  totalTemas: number;
};

export const thesisService = {
  list: async (filters?: { nome?: string; ticker?: string }): Promise<TeseSummaryDto[]> => {
    try {
      const response = await ApiClient.get<TeseSummaryDto[]>('/api/v1/teses', {
        params: filters || {},
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao listar teses:', error);
      return [];
    }
  },

  getById: async (id: string): Promise<TeseDetailDto | null> => {
    try {
      const response = await ApiClient.get<TeseDetailDto>(`/api/v1/teses/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar detalhe da tese:', error);
      return null;
    }
  },

  save: async (payload: SaveTeseRequestDto): Promise<TeseDetailDto | null> => {
    try {
      const response = await ApiClient.post<TeseDetailDto>('/api/v1/teses', payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar tese:', error);
      return null;
    }
  },

  getUsage: async (): Promise<BillingUsageDto | null> => {
    try {
      const response = await ApiClient.get<BillingUsageDto>('/api/v1/billing/usage');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar uso de billing:', error);
      return null;
    }
  },

  listGoogleNewsPaises: async (): Promise<GoogleNewsPaisDto[]> => {
    try {
      const response = await ApiClient.get<GoogleNewsPaisDto[] | string>('/configuracoes/google-news/paises');
      const raw = response.data;
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw) as GoogleNewsPaisDto[];
        } catch {
          return [];
        }
      }
      return Array.isArray(raw) ? raw : [];
    } catch (error) {
      console.error('Erro ao listar países Google News:', error);
      return [];
    }
  },
};
